import type { PlatformLegalInfo } from '../../services/platformLegalInfoService';

/** The data controller block on the legal pages; renders nothing until the identity is published. */
function LegalIdentity({ info }: { info: PlatformLegalInfo }) {
  if (!info.isPopulated) return null;

  const rows: Array<[string, string]> = [
    ['Company', info.controllerName],
    ['Registered office', info.addressLines.join(', ')],
    ['Trade register number', info.commercialRegister],
    ['Tax ID', info.vatId],
    ['Email', info.contactEmail],
    ['Phone', info.phone],
  ];

  return (
    <dl className="legal-identity">
      {rows
        .filter(([, value]) => value !== '')
        .map(([label, value]) => (
          <div key={label} className="legal-identity-row">
            <dt>{label}</dt>
            <dd>{value}</dd>
          </div>
        ))}
    </dl>
  );
}

export default LegalIdentity;
